<template>
  <div class="container">
    <div class="search_box">
      <el-form ref="form" class="search_form" :model="tableParams" label-position="left">
        <el-form-item label="搜索内容" label-width="70px">
          <el-input v-model="tableParams.orgName" placeholder="请输入名称/联系人/电话" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" class="search_area_btn" @click="onSubmit">搜索</el-button>
          <el-button icon="el-icon-plus" class="search_area_btn" @click="addOrg">新增</el-button>
          <el-button icon="el-icon-upload2" class="search_area_btn" @click="downloadExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table_box">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="未处理" name="1"></el-tab-pane>
        <el-tab-pane label="已处理" name="2"></el-tab-pane>
      </el-tabs> -->
      <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
        v-loading="tableLoading">
        <!--  :height="tableHeight" -->
        <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
        <el-table-column property="orgName" label="企业名称" width="200"></el-table-column>
        <el-table-column property="orgSimpleName" label="企业简介" width="120"></el-table-column>
        <el-table-column property="creditCode" label="统一社会信用代码" width="180"></el-table-column>
        <el-table-column property="head" label="企业负责人" width="120"></el-table-column>
        <el-table-column property="phone" label="负责人手机号" width="120"></el-table-column>
        <el-table-column property="areaName" label="所属区域" width="200"></el-table-column>
        <el-table-column property="addr" label="详细地址" width="360"></el-table-column>
        <el-table-column property="carNum" label="车辆总数" width="120"></el-table-column>
        <el-table-column property="terNum" label="终端总数" width="120"></el-table-column>
        <el-table-column property="addOrderNum" label="新装工单（车辆）" width="150"></el-table-column>
        <el-table-column property="updateOrderNum" label="维护工单（车辆）" width="150"></el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goReadct(scope.row)">修改</el-button>
            <el-button type="text" @click="goDetele(scope.row)">删除</el-button>
            <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="paging_box">
        <!--  :current-page="currentPage4" -->
        <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <v-add :show.sync="addShow"></v-add>
    <v-redact :show.sync="redactShow" :data="redactData"></v-redact>
    <v-detail :show.sync="detailShow" :data="detailData"></v-detail>
  </div>
</template>

<script>
import add from './component/add.vue';
import redact from "./component/redact.vue";
import detail from "./component/detail.vue"
import config from '@/utils/config';
export default {
  name: "",
  data () {
    return {
      tableData: [],
      tableParams: {
        page: 1,
        limit: 10,
        orgName: "",
      },
      solveStatus: null,
      total: 0,
      tableLoading: false,
      stateList: [{
        value: 0,
        label: '未处理'
      }, {
        value: 1,
        label: '已确认'
      }, {
        value: 2,
        label: '被驳回'
      }, {
        value: 3,
        label: '未处理(处理中)'
      }, {
        value: 4,
        label: '已处理'
      },],
      timeList: [],
      addShow: false,
      addData: {},
      redactShow: false,
      redactData: {},
      detailShow: false,
      detailData: {},
      userInfo: "",
    };
  },
  components: {
    "v-add": add,
    "v-redact": redact,
    "v-detail": detail
  },
  props: {},
  created () {
    this.getList();
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  },
  methods: {
    getList () {
      this.$http.queryOrgList(this.tableParams).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.$message.error(res.msg);
        }
      });
    },
    onSubmit () {
      this.tableParams.solveStatus = this.solveStatus;
      this.getList();
    },
    downloadExport() {
      var data=this.tableParams;
      var url=config.baseUrl+'/org/exportOrgList?Authorization='+sessionStorage.getItem("Token");
      if(data.orgName){
        url+='&orgName='+data.orgName;
      }
      window.open(url, '_blank');
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    },
    addOrg () {
      this.addShow = true
    },
    goReadct (row) {
      this.redactShow = true;
      this.redactData = row;
    },
    goDetail (row) {
      this.detailShow = true;
      this.detailData = row;
    },
    goDetele (row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delOrg({ ids: row.id }).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.getList()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            });
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    timeChange (e) {
      if (e == null) {
        this.tableParams.startTime = "";
        this.tableParams.endTime = "";
      } else {
        this.tableParams.startTime = dateTransition(e[0]);
        this.tableParams.endTime = dateTransition(e[1]);
      }
    },
    handleClick (e) {
      if (e.index == '0') {
        this.tableParams.solveStatus = 0
        this.getList();
      } else if (e.index == '1') {
        this.tableParams.solveStatus = 4
        this.getList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
</style>



// WEBPACK FOOTER //
// src/views/company_Admin/company_Admin.vue